import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

function DeleteModelConfirmationModal({
  modalIsOpen, modelName, modelId, closeModal,
}) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={() => closeModal()}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--confirm-item-delete">
          <div className="l-inner-large">
            <h2 className="content-heading__h2 text-semibold">Attention!</h2>
            <p>
              You are about to permanently delete "{modelName}" from your library! Deleting a model can have a
              severely negative impact on your sales performance and reduce organic buyer traffic to your
              profile via CGTrader search and 3rd party search engines (Google, Bing, etc.). Deleted models
              are taken off the marketplace and cannot be recovered.
            </p>
            <p>
              If you want to make changes to the model, select the <span className="text-semibold">Edit</span> option. To improve
              your sales and search ranking, we recommend taking a look at
              the <a href="/profile/analytics/improvements" target="_blank" className="link--primary-dark">Model improvements</a> page
              in your profile.
            </p>
            <div className="u-text-right">
              <a href={`/profile/items/${modelId}`} data-method="delete" className="btn btn-outline-default btn-fat u-mt10 u-mr10">
                Delete Model
              </a>
              <button className="btn btn-primary btn-fat u-mt10" onClick={() => closeModal()}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

DeleteModelConfirmationModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  modelName: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default DeleteModelConfirmationModal
